export const BASE_API = process.env.VUE_APP_BASE_API || 'https://cs.jialebi.net'
export const ASSET_ORIGIN = 'https://cs.jialebi.net'
export const WS_URL = process.env.VUE_APP_WS_URL || 'wss://cs.jialebi.net:1818'

export const API = {
  accountLogin: '/addons/shopro/user/accountLogin',
  userIndex: '/addons/shopro/user/index',
  sessions: '/api/Field_bee_customer_portal/sessions',
  chatLogs: '/api/Field_bee_customer_portal/chatLogs',
  pool: '/api/Field_bee_customer_portal/pool',
  poolDetail: '/api/Field_bee_customer_portal/poolDetail',
  recep: '/api/Field_bee_customer_portal/recep',
  getPoolStatistics: '/api/Field_bee_customer_portal/getPoolStatistics',
  getAddress: '/api/Field_bee_customer_portal/getAddress',
  addAddress: '/api/Field_bee_customer_portal/addAddress',
  editAddress: '/api/Field_bee_customer_portal/editAddress',
  areaData: '/addons/shopro/address/area',
  wqfCategory: '/api/wqf/category',
  wqfServiceDetail: '/api/wqf/serviceDetail',
  wqfQuote: '/api/wqf/quote',
  createOrder: '/api/Field_bee_customer_portal/createOrder',
  setPriceRate: '/api/Field_bee_customer_portal/setPriceRate',
  orderList: '/api/Field_bee_client/orderList',
  orderDetail: '/api/Field_bee_client/orderDetail'
}
